import React from "react";
import clsx from "clsx";
import { useNavigate } from "react-router";
import useBuildingMenu from "./useBuildingMenu";
import { MenuItemProps } from "./MenuItem";
import Tooltip from "components/Tooltip";

const SubMenuItem = ({
  item,
  ...props
}: {
  item: MenuItemProps;
  className?: string;
  highlight?: boolean;
}) => {
  const navigate = useNavigate();
  const { isMenuSelected } = useBuildingMenu();
  const isSelected = isMenuSelected(item);

  const navigateToPath = () => {
    if (item.path) {
      item.path && navigate(item.path, { state: location.pathname });
    } else if (item?.openConfirmModal) {
      item.openConfirmModal?.();
      return false;
    }
  };

  return (
    <Tooltip
      content={item.tooltip || ""}
      className={clsx(
        item.disable ? "!cursor-not-allowed" : "",
        props.className
      )}
    >
      <div
        className={clsx(
          "flex items-center py-2 px-3 hover:bg-indigo-50 cursor-pointer",
          "group/subItem rounded-md relative transition",
          "text-sm font-medium whitespace-normal mb-[10px] last-of-type:mb-0 w-full",
          {
            "bg-indigo-50": isSelected,
            "opacity-30 !cursor-not-allowed pointer-events-none": item.disable,
          }
        )}
        onClick={navigateToPath}
      >
        <div
          className={clsx(
            "text-gray-500 group-hover/subItem:text-white transition flex items-center justify-center",
            "rounded-md p-[2px] bg-gray-50 group-hover/subItem:bg-indigo-500 min-w-[40px] min-h-[40px]",
            {
              "bg-indigo-500 text-white": isSelected,
              "bg-purple-50 text-purple-500": !isSelected && props.highlight,
            }
          )}
        >
          {item.icon}
        </div>
        <div className="ml-4 text-sm">
          <div
            className={clsx(
              "text-gray-900 group-hover/subItem:text-indigo-700 font-medium mb-1 transition",
              { "text-indigo-700": isSelected }
            )}
          >
            {item.name}
          </div>
          <div
            className={clsx(
              "text-gray-600 group-hover/subItem:text-indigo-500 transition text-sm font-normal",
              { "text-indigo-500": isSelected }
            )}
          >
            {item.subtitle}
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default SubMenuItem;
